import { render, staticRenderFns } from "./Staircase.vue?vue&type=template&id=7a9ec175&scoped=true"
import script from "./Staircase.vue?vue&type=script&lang=js"
export * from "./Staircase.vue?vue&type=script&lang=js"
import style0 from "./Staircase.vue?vue&type=style&index=0&id=7a9ec175&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9ec175",
  null
  
)

export default component.exports